<template>
  <div ref="createModal" class="modal fade" id="modal-shop" tabindex="-1">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ params.data.title }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <template v-if="isNotLoad()">
            <div class="col-12">
              <div class="card" id="promocodes-multiselect">
                <div class="card-body">
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="mb-3">
                          <label class="form-label">Магазин</label>
                          <Multiselect
                            v-model="fields.shop_id"
                            :close-on-select="true"
                            :multiple="false"
                            placeholder="Выберите магазин"
                            noResultsText="Результатов не найдено"
                            :options=getShops()
                            :searchable="true"
                            :internal-search="true"
                            label="title"
                            track-by="title"
                          >
                            <template v-slot:singlelabel="{ value }">
                              <div class="multiselect-single-label option-item">
                                <div class="item-image-wrap">
                                  <img class="item-image" :src="value.image">
                                </div>
                                <div class="item-name">{{ value.title }}</div>
                              </div>
                            </template>
                            <template v-slot:option="{ option }">
                              <div class="option-item">
                                <div class="item-image-wrap">
                                  <img class="item-image" :src="option.image">
                                </div>
                                <div class="item-name">{{ option.title }}</div>
                              </div>
                            </template>
                          </Multiselect>
                          <span :class="{'is-invalid': v$.shop_id.$invalid && v$.shop_id.$dirty}"></span>
                          <div class="invalid-feedback" v-for="error of v$.shop_id.$errors" :key="error.$uid">
                            {{ error.$message }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="mb-3">
                          <label class="form-label">Источник</label>
                          <Multiselect
                            v-model="fields.source_id"
                            @change="onChangeSource"
                            :close-on-select="true"
                            :multiple="false"
                            placeholder="Выберите источник"
                            noResultsText="Результатов не найдено"
                            :options=getSources()
                            :searchable="true"
                            :internal-search="true"
                            label="title"
                            track-by="title"
                          >
                            <template v-slot:singlelabel="{ value }">
                              <div class="multiselect-single-label option-item">
                                <div class="item-image-wrap">
                                  <img class="item-image" :src="value.image">
                                </div>
                                <div class="item-name">{{ value.title }}</div>
                              </div>
                            </template>
                            <template v-slot:option="{ option }">
                              <div class="option-item">
                                <div class="item-image-wrap">
                                  <img class="item-image" :src="option.image">
                                </div>
                                <div class="item-name">{{ option.title }}</div>
                              </div>
                            </template>
                          </Multiselect>
                          <span :class="{'is-invalid': v$.source_id.$invalid && v$.source_id.$dirty}"></span>
                          <div class="invalid-feedback" v-for="error of v$.source_id.$errors" :key="error.$uid">
                            {{ error.$message }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="mb-3">
                          <label class="form-label">Компания</label>
                          <Multiselect
                            v-model="fields.campaign_id"
                            :close-on-select="true"
                            :multiple="false"
                            placeholder="Выберите компанию"
                            noResultsText="Результатов не найдено"
                            :options=getCampaigns()
                            :searchable="true"
                            :internal-search="true"
                            label="title"
                            track-by="title"
                          >
                            <template v-slot:singlelabel="{ value }">
                              <div class="multiselect-single-label option-item">
                                <div class="item-image-wrap">
                                  <img class="item-image" :src="value.image">
                                </div>
                                <div class="item-name">{{ value.title }}</div>
                              </div>
                            </template>
                            <template v-slot:option="{ option }">
                              <div class="option-item">
                                <div class="item-image-wrap">
                                  <img class="item-image" :src="option.image">
                                </div>
                                <div class="item-name">{{ option.title }}</div>
                              </div>
                            </template>
                          </Multiselect>
                          <span :class="{'is-invalid': v$.campaign_id.$invalid && v$.campaign_id.$dirty}"></span>
                          <div class="invalid-feedback" v-for="error of v$.campaign_id.$errors" :key="error.$uid">
                            {{ error.$message }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="d-flex justify-content-center">
              <div class="spinner-border"></div>
            </div>
          </template>
        </div>
        <template v-if="isNotLoad()">
          <div class="modal-footer">
            <button class="btn btn-secondary" data-bs-dismiss="modal">
              Отмена
            </button>
            <button class="btn btn-primary ms-auto" @click="send" :class="{'disabled': isPending()}">
              <span class="spinner-border spinner-border-sm me-2" v-show="isPending()"></span>
              {{ params.data.btn }}
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {computed, reactive, ref, onMounted, defineComponent} from 'vue'
import {useVuelidate} from "@vuelidate/core"
import {required} from "@/plugins/vuelidator"
import createParams from "./services/params/create"
import Api from "@/modules/promocodes/pages/shops/services/Api"
import Notify from "@/services/Notify"
import Multiselect from "@/plugins/multiselect"
import Image from "@/services/Image"

export default defineComponent({
  name: "CreateLink",
  components: {
    Multiselect,
  },
  setup(props, {emit}) {
    const slotname = "singleLabel"
    const createModal = ref(null)
    const fields = reactive(getFields())

    let load = ref(false)
    let pending = ref(false)
    let bootModal = null
    let $externalResults = reactive({})
    let params = ref(getParams())
    let shops = ref([])
    let sources = ref([])
    let campaigns = ref([])

    const rules = computed(() => ({
      shop_id: {
        required
      },
      source_id: {
        required
      },
      campaign_id: {
        required
      },
    }))

    const v$ = useVuelidate(rules, fields, {$externalResults});

    function getParams() {
      return {
        data: {
          title: "",
          btn: "",
          page: "",
        }
      }
    }

    function resetParams() {
      params.value = getParams()
    }

    function isNotLoad() {
      return load.value === false
    }

    function markLoad() {
      return load.value = true
    }

    function markUnload() {
      return load.value = false
    }

    function isPending() {
      return pending.value === true
    }

    function markPending() {
      return pending.value = true
    }

    function markUnpending() {
      return pending.value = false
    }

    function getFields() {
      return {
        shop_id: null,
        campaign_id: null,
        source_id: null,
      }
    }

    function validate(fn) {
      clearValidate()
      return v$.value.$validate().then((resp) => {
        if (resp === false) {
          Notify.error("Ошибка валидации")
          return false
        }
        fn()
      })
    }

    function clearValidate() {
      v$.value.$clearExternalResults()
      v$.value.$reset()
    }

    function showModal(event) {
      loadShops()
      loadSources()

      setParams(createParams)
      create(event)
    }

    function setParams(val) {
      params.value = val
    }

    function create() {
      clearForm()
      markUnload()
    }

    function loadShops() {
      Api.shops({
        limit: 10000,
        offset: 0,
      }).then((resp) => {
        let items = resp.data.data
        let filtered = []

        for (let prop in items) {
          let obj = items[prop]
          let image = null

          if (obj["shop_image_host"] && obj["shop_image_name"]) {
            image = Image.handle(obj["shop_image_host"], obj["shop_image_name"], 60)
          }

          filtered.push({
            value: obj["shop_id"],
            title: obj["shop_name"],
            image: image,
          })
        }

        shops.value = filtered
      }).catch(() => {})
        .finally(() => {})
    }

    function getSourceImage(sourceId) {
      let sourceImage = ""

      switch (sourceId) {
        case 1: sourceImage = "/assets/static/sources/admitad.svg"
        break
        case 2: sourceImage = "/assets/static/sources/advcake.svg"
        break
      }
      return sourceImage
    }

    function loadSources() {
      Api.sources().then((resp) => {
        let items = resp.data.data
        let filtered = []

        for (let prop in items) {
          let obj = items[prop]

          filtered.push({
            value: obj["source_id"],
            title: obj["source_name"],
            image: getSourceImage(obj["source_id"]),
          })
        }

        sources.value = filtered
        if (filtered.length > 0) {
            fields.source_id = filtered[0].value
            loadCampaigns(filtered[0].value)
        }
      }).catch(() => {})
        .finally(() => {})
    }

    function loadCampaigns(sourceId) {
      Api.campaigns({
        limit: 10000,
        offset: 0,
        source_id: sourceId,
        is_not_linked: true,
      }).then((resp) => {
        let items = resp.data.data
        let filtered = []

        for (let prop in items) {
          let obj = items[prop]

          filtered.push({
            value: obj["campaign_id"],
            title: obj["campaign_name"],
            image: getSourceImage(fields.source_id),
          })
        }

        campaigns.value = filtered
      }).catch(() => {})
    }

    function onChangeSource(value) {
      resetCampaign()

      if (value && value > 0) {
        loadCampaigns(value)
      }
    }

    function resetCampaign() {
      fields.campaign_id = null
    }

    function preShowModal() {
      markLoad()
      resetParams()
      clearValidate()
    }

    onMounted(() => {
      bootModal = new bootstrap.Modal(createModal.value, {
        backdrop: 'static',
        keyboard: false
      });

      createModal.value.addEventListener('click', function (e) {
        if (e.target === createModal.value) {
          const shouldClose = confirm("Закрыть окно?");
          if (shouldClose) {
            bootModal.hide();
          }
        }
      });

      createModal.value.addEventListener('shown.bs.modal', showModal);
      createModal.value.addEventListener('show.bs.modal', preShowModal);
    })

    function getPayload(obj) {
      const formData = new FormData()

      Object.entries(obj).forEach(([key, val]) => {
        formData.append(key, val)
      })

      return formData
    }

    function send() {
      validate(() => {
        markPending()

        let obj = {
          shop_id: fields.shop_id,
          campaign_id: fields.campaign_id,
          source_id: fields.source_id,
        }

        let payload = getPayload(obj)
        
        params.value.action({
          modal: bootModal,
          payload,
        }).then((resp) => {
          clearForm()
          clearValidate()
          Notify.success(resp)
          emit("onAddLink")
        }).catch((resp) => {
          Notify.error(resp)
        }).finally(() => {
          markUnpending()
        })
      })
    }

    function clearForm() {
      let items = getFields()
      for (let key of Object.keys(items)) {
        fields[key] = items[key]
      }
    }

    function getShops() {
      return shops.value
    }

    function getSources() {
      return sources.value
    }

    function getCampaigns() {
      return campaigns.value
    }

    return {
      slotname,
      isNotLoad,
      v$,
      fields,
      createModal,
      send,
      isPending,
      params,
      getShops,
      getSources,
      getCampaigns,
      onChangeSource,
    }
  }
})
</script>
